/**
 * Override set function to handle web and native differences
 * @param {Function} _set
 * @returns {Function} set
 */
const Setter = (_set) => {
  const set = (state) => {
    _set(state);
  };
  return set;
};

/**
 * Set storage for web and native
 * @param {String} _storage
 * @returns {Object} storage
 */
const Store = (_storage = "local") => {
  let storage;
  switch (_storage) {
    case "local":
      storage = localStorage;
      break;
    case "session":
      storage = sessionStorage;
      break;
    default:
      storage = localStorage;
  }

  return storage;
};

export { Setter, Store };
